import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import type { NonGenerativeAIAnswerResultShownProps } from './types';

// When the user clicks the Jira issue key in the Jira NL to JQL smart card
export const onJiraIssueKeyClicked: ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	issuekey,
	answerCardType,
	answerString,
	isAuxClick,
	isContextMenu,
}: NonGenerativeAIAnswerResultShownProps & {
	issuekey?: string;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
}) => AnalyticsEventPayload = ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	issuekey,
	answerCardType,
	answerString,
	isAuxClick,
	isContextMenu,
}: NonGenerativeAIAnswerResultShownProps & {
	issuekey?: string;
	isAuxClick?: boolean;
	isContextMenu?: boolean;
}): AnalyticsEventPayload => {
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerJiraCardWorkItemLink',
		source,
		eventType: 'ui',
		attributes: {
			searchSessionId,
			queryHash,
			brand,
			source,
			answerCardType,
			isAuxClick,
			isContextMenu,
		},
		nonPrivacySafeAttributes: {
			answerString,
			query,
			issuekey,
		},
	};
};
